import { lb } from '../FieldOpsKit'

/** Status labels/tones shared by the Drivers screens. "Delayed" is derived (see store.isDelayed), never stored. */
export const STATUS_VIEW = {
    planned: { label: 'Planned', tone: 'gray' },
    out: { label: 'Out for delivery', tone: 'blue' },
    delivered: { label: 'Delivered', tone: 'green' },
    cancelled: { label: 'Cancelled', tone: 'red' },
}

/** Load of a driver's day vs the capacity of the assigned vehicle. */
export const loadOf = (drivers, driverId, list) => {
    const d = drivers.drivers.filter((x) => x.id === driverId)[0]
    const v = d ? drivers.vehicles.filter((x) => x.id === d.vehicleId)[0] : null
    const weight = list.filter((x) => x.driverId === driverId && x.status !== 'cancelled').reduce((a, x) => a + x.weightLb, 0)
    return { weight: weight, capacity: v ? v.capacityLb : 0, vehicle: v, over: v ? weight > v.capacityLb : false, label: v ? lb(weight) + ' of ' + lb(v.capacityLb) : lb(weight) }
}

/** Printable route sheet for one driver and day (opens the browser print dialog). */
export const printRouteSheet = (driverName, vehicleName, date, stops) => {
    const w = window.open('', '_blank')
    if (!w) return false
    const rows = stops.map((s, i) => '<tr><td>' + (i + 1) + '</td><td>' + s.invoiceNo + '</td><td><strong>' + s.customer + '</strong><br>' + s.address + ', ' + s.city + '<br>' + s.phone + '</td><td>' + s.window + '</td><td>' + s.weightLb.toLocaleString('en-US') + ' lb</td><td>' + (s.notes || '') + '</td><td style="width:90px"></td></tr>').join('')
    w.document.write('<html><head><title>Route sheet</title><style>body{font-family:Arial,sans-serif;padding:24px;color:#0F172A}h1{font-size:20px;margin:0}p{margin:2px 0 14px;color:#475569}table{width:100%;border-collapse:collapse;font-size:12px}th,td{border:1px solid #CBD5E1;padding:6px;text-align:left;vertical-align:top}th{background:#F1F5F9}</style></head><body><h1>Route sheet · ' + driverName + '</h1><p>' + date + ' · ' + vehicleName + ' · ' + stops.length + ' stops</p><table><thead><tr><th>#</th><th>Invoice</th><th>Customer / address</th><th>Window</th><th>Weight</th><th>Notes</th><th>Signature</th></tr></thead><tbody>' + rows + '</tbody></table></body></html>')
    w.document.close()
    w.focus()
    setTimeout(() => w.print(), 300)
    return true
}
